/* global axios */

import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  buildPayload(data) {
    if (!data || !(data.attachment instanceof File)) {
      return data;
    }

    const formData = new FormData();
    Object.entries(data).forEach(([key, value]) => {
      if (value === undefined || value === null) return;
      if (value instanceof File) {
        formData.append(`campaign[${key}]`, value);
      } else if (typeof value === 'object') {
        formData.append(`campaign[${key}]`, JSON.stringify(value));
      } else {
        formData.append(`campaign[${key}]`, String(value));
      }
    });
    return formData;
  }

  create(data) {
    return axios.post(this.url, this.buildPayload(data));
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, this.buildPayload(data));
  }

  analyticsMetrics(id) {
    return axios.get(`${this.url}/${id}/analytics/metrics`);
  }

  analyticsContacts(id, { status, page } = {}) {
    return axios.get(`${this.url}/${id}/analytics/contacts`, {
      params: { status, page },
    });
  }
}

export default new CampaignsAPI();
